import { ArrowRefresh } from 'blaze-ui/icons'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import Styles from './CampaignDetails.module.scss'
import cx from 'classnames'

interface RegenButtonProps {
  ariaLabel: string
  onRegenerate: () => void
  isDisabled?: boolean
  isRegenerating: boolean
}

export const RegenButton = ({ ariaLabel, onRegenerate, isDisabled, isRegenerating }: RegenButtonProps) => {
  return (
    <div className={cx({ [Styles.regenButtonSpinning]: isRegenerating })}>
      <IconButton
        icon={ArrowRefresh}
        size="sm"
        variant="tertiary"
        onPress={onRegenerate}
        isDisabled={isDisabled}
        aria-label={ariaLabel}
      />
    </div>
  )
}
